<template>
<div>
    <div class="container">
        <div id="btn-open-caja" class="d-flex justify-content-end pt-2 mt-4">
            <div class="btn-group btn-home" role="group">
                <button type="button" class="btn btn-outline-main bg-main text-white" @click="mtdBackCampus">
                    <i class="fas fa-recycle"></i> Cambiar de Sede
                </button>
            </div>
        </div>
        <div class="row row-home mt-3" id="div_conte_2">
            <div id="div_conte-home" class="col-md-10 mx-auto">
                <div class="bg-secondary text-white bg-opacity-10">
                    <div class="text-center py-4 px-5">
                        <div class="row row-home d-flex flex-column align-items-center">
                            <button class="div-campus fw-bold col-6 m-2 p-2 text-white" @click="changePage('doctor')">
                                MÉDICO
                            </button>
                            <button class="div-campus fw-bold col-6 m-2 p-2 text-white" @click="changePage('nurse')">
                                ENFERMERA
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script>
export default {
    name: 'homeMaintenance',
    data() {
        return {
            page: null
        }
    },
    methods: {
        changePage(page) {
            this.$emit('changePage', page)
        },
        mtdBackCampus: function () {
            this.$emit('mtdBackCampus')
        },
    }
}
</script>
